import { InjectionToken } from '@angular/core';
import {
  signInWithEmailAndPassword, signInWithPopup, signInAnonymously, signOut,
  sendPasswordResetEmail, sendEmailVerification,
} from '@angular/fire/auth';

// Keep Firebase's ESM functions behind one injectable boundary for deterministic effect tests.
export const firebaseAuthOperations = {
  signInWithEmailAndPassword, signInWithPopup, signInAnonymously, signOut,
  sendPasswordResetEmail, sendEmailVerification,
};
export type FirebaseAuthOperations = typeof firebaseAuthOperations;
export const AUTH_EFFECT_OPERATIONS = new InjectionToken<FirebaseAuthOperations>('Auth effect operations', {
  providedIn: 'root',
  factory: () => firebaseAuthOperations,
});
